import { render } from "./excel-parser-epmty.vue?vue&type=template&id=84d53f88"
import script from "./excel-parser-epmty.vue?vue&type=script&lang=js"
export * from "./excel-parser-epmty.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__